import axios from "axios";
import APIURLMaker from "../utils/APIURLMaker";

export const ssoapi = {
  /**
   * Exchange SSO token (from Google or other providers) for app JWT token
   * @param {string} provider - SSO provider name (e.g., "google")
   * @param {string} foreignToken - The SSO token from the provider
   * @returns {Promise<string>} The app JWT token
   */
  exchangeToken: async (provider, foreignToken) => {
    try {
      const url = APIURLMaker(`/auth/sso/${provider}`);
      
      const response = await axios.post(url, null, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${foreignToken}`,
        },
      });

      if (!response.data?.jwtToken) {
        throw new Error("Backend did not return jwtToken");
      }

      return response.data.jwtToken;
    } catch (error) {
      console.error("SSO token exchange error:", error);
      
      // Extract error message from response if available
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          "SSO exchange failed";
      
      throw new Error(errorMessage);
    }
  },
};

export default ssoapi;
